import store from '../store'

// Rotas públicas que não exigem autenticação
const PUBLIC_ROUTES = ['login', 'cadastrar', 'recuperaracesso', 'informarsenha', 'verificarEmail']

export default async (to, from, next) => {
    document.title = 'StoneUP Negativa'

    const isPublicRoute = PUBLIC_ROUTES.includes(to.name)
    const hasToken = store.getters['auth/hasToken']

    // Usuário autenticado tentando acessar rota pública → redireciona para home
    if (isPublicRoute && hasToken) {
        return next({ name: 'Home' })
    }

    // Rota pública sem token → permite acesso normalmente
    if (isPublicRoute) {
        return next()
    }

    // Rota protegida: verifica se há token válido
    if (!hasToken) {
        try {
            await store.dispatch('auth/ActionCheckToken')
            return next()
        } catch {
            return next({ name: 'login' })
        }
    }

    // Token já está no store, segue normalmente
    return next()
}
